import { makeStyles } from "@mui/styles";

export const ratingStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    cursor: "pointer",
    flexWrap: "wrap",

    [theme.breakpoints.up("md")]: {
      marginRight: "10%",
    },
  },
  container2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,

    [theme.breakpoints.up("md")]: {
      marginRight: "10%",
    },
  },
  helpText: {
    fontSize: "0.8rem",
  },
}));
